<template>
  <div class="promotion-section__container"
       v-if="promotions && promotions.length">
    <div class="content-section no-margin-top content-section__bordered border-1-20 promotion-section__content"
         :ref="'promotion-' + promotion.id"
         v-for="promotion of promotions">
      <div>
        <div>
          <div class="content-section-title color-1-100 background-1-100-before">
            <h3>{{ promotion.title }}</h3>
          </div>
          <div class="content-section-text" v-html="promotion.text"></div>
          <a :href="promotion.link" class="content-section-button border-1-60"
             v-if="promotion.link && promotion.button && promotion.link !== '' && promotion.button !== ''">
            {{ promotion.button }}
          </a>
        </div>
        <img class="content-section-image" v-bind:alt="promotion.imageAlt" :src="getImageFullPath(promotion.image)" />
      </div>
      <button class="content-section-close" v-on:click="hidePromotion(promotion.id)">Dismiss info</button>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'promotions',
    data () {
      return {
        canShowPromotions: true,
        activePromotions: [],
        promotions: []
      }
    },
    methods: {
      getActivePromotions () {
        this.$http.get(`${api.URLS.promotions}/active`, api.headersAuthSettings).then((res) => {
          if (res.body) {
            this.activePromotions = res.body
            this.filterPromotions()
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      getImageFullPath (image) {
        return `${api.serverURL}/uploads/images/content/${image}`
      },
      hidePromotion (id) {
        localStorage.setItem('hidePromotion-' + id, 'true')
        this.filterPromotions()
      },
      filterPromotions () {
        this.promotions = this.activePromotions.filter(p => {
          const promotionHidden = localStorage.getItem('hidePromotion-' + p.id)
          return !promotionHidden
        })
      }
    },
    mounted () {
      this.getActivePromotions()
    }
  }
</script>

<style src="@/assets/scss/components/dashboard.scss" lang="scss" scoped />
<style src="@/assets/scss/components/promotions.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// Promotions.vue?22fc4cda